import { Radio as AlchemyRadio } from '@m/alchemy-ui/Radio';
import styled from 'styled-components';

export const Radio = styled(AlchemyRadio)`
  min-height: 24px;
  padding-left: 32px;
  input {
    width: 24px;
    height: 24px;
  }
  span {
    width: 24px;
    height: 24px;
    border-radius: 12px;
    vertical-align: sub;
    span {
      width: 12px;
      height: 12px;
      border-width: 6px;
    }
  }
`;
